import en from './translations/en.json'
import ru from './translations/ru.json'
import de from './translations/de.json'
import es from './translations/es.json'
import it from './translations/it.json'
import fr from './translations/fr.json'
import ch from './translations/ch.json'
import uk from './translations/uk.json'
import ar from './translations/ar.json'

export default {
  en: en,
  ru: ru,
  de: de,
  es: es,
  it: it,
  fr: fr,
  ch: ch,
  uk: uk,
  ar: ar,
}
